export const SHOW_IDLE_MODE = 'SHOW_IDLE_MODE' as const;
export const HIDE_IDLE_MODE = 'HIDE_IDLE_MODE' as const;

export const showIdleMode = () => ({ type: SHOW_IDLE_MODE });
export const hideIdleMode = () => ({ type: HIDE_IDLE_MODE });
